import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

// Типы для функции подтверждения
type ConfirmFunction = (
  message: string,
  onConfirm: () => void,
  onCancel?: () => void
) => void;

// Функция подтверждения
export const confirm: ConfirmFunction = (message, onConfirm, onCancel) => {
  confirmAlert({
    title: 'Confirm',
    message,
    buttons: [
      {
        label: 'Yes',
        onClick: onConfirm,
      },
      {
        label: 'No',
        onClick: onCancel || (() => {}),
      },
    ],
  });
};

